import React from 'react';
import { Select } from '@nextiva/next-ui';
export default (function (props) {
  var children = props.children,
      options = props.options,
      onOperatorChange = props.onOperatorChange,
      operator = props.operator,
      onFocus = props.onFocus;
  return React.createElement("div", {
    className: "nx-filter-column"
  }, React.createElement("div", {
    className: "nx-filter-column__condition"
  }, React.createElement(Select, {
    options: options,
    value: operator,
    onChange: onOperatorChange,
    onFocus: onFocus,
    disabled: options.length === 1
  })), children);
});